import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MasterHome from "./shared/modules/admin/MasterHome";
import { GetConfigurationPageSetup, getUser } from "./shared/services/services";
import { useUser } from "./business-types/grocery/components/UserContext";
import Signup from "./features/auth/pages/Signup";
import GroceryNavigations from "./shared/routes/GroceryNavigations";
import Login from "./shared/modules/admin/auth/Login";
import SetPassword from "./shared/modules/admin/SetPassword";
import ForgotPassword from "./shared/modules/admin/ForgotPassword";
import ResetPassword from "./shared/modules/admin/ResetPassword";
import { errorHandling } from "./shared/utils/errorHandling";
import { IS_STANDALONE } from "./features/auth/axiosConfig";
import NotFound from "./shared/modules/admin/NotFound";
import ProtectedRoutes from "./shared/routes/ProtectedRoutes";

const isTokenValid = (): boolean => {
  const token = sessionStorage.getItem("jsonwebtoken");
  return !!token;
};

export const basepath = process.env.REACT_APP_BASEPATH;

const App: React.FC = () => {
  const [employee, setemployee] = useState<boolean>(false);
  const { setUser, setConfigurations } = useUser();
  console.log(employee);
  useEffect(() => {
    const check_on = () => {
      const employee_login = sessionStorage.getItem("employee");
      const employee_data = sessionStorage.getItem("Noemployee");
      if (employee_login) {
        setemployee(true);
      } else if (employee_data) {
        setemployee(false);
      }
    };
    check_on();
  }, []);

  const tokenValid = isTokenValid();

  useEffect(() => {
    if (!tokenValid) return;

    getUser()
      .then((res) => {
        const userDetails = res.data.user_details;

        let updatedUser = { ...userDetails };
        const standalone = IS_STANDALONE

        if (standalone) {
          updatedUser.companyLogo = `data:image/png;base64,${userDetails.image_url}`;
        }

        setUser(updatedUser);
      })
      .catch((error) => console.error("User check failed:", error));

    GetConfigurationPageSetup()
      .then((res) => {
        const useConfig = res?.data?.result?.[0];
        if (useConfig) setConfigurations(useConfig);
      })
      .catch((error) => errorHandling(error));

  }, [tokenValid]);


  return (
    <BrowserRouter basename={basepath}>
      <Routes>
        <Route path='/' element={<Login />} />
        <Route path='/imetanic/setpassword/:userid/:expiryTime/2580' element={<SetPassword />} />
        <Route path='/sign-up' element={<Signup />} />
        <Route path='/forgot-password' element={<ForgotPassword />} />
        <Route path='/reset-password/:token' element={<ResetPassword />} />
        <Route path='/v1/*' element={<ProtectedRoutes />} />
        <Route path='/master-home' element={<MasterHome />} />
        <Route path='/grocery/*' element={<GroceryNavigations />} />
        <Route path='*' element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
